import { render, staticRenderFns } from "./progress-button.vue?vue&type=template&id=2233fc25&scoped=true&"
import script from "./progress-button.vue?vue&type=script&lang=js&"
export * from "./progress-button.vue?vue&type=script&lang=js&"
import style0 from "./progress-button.vue?vue&type=style&index=0&id=2233fc25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233fc25",
  null
  
)

export default component.exports